import React from "react";
import { Header as UIHeader } from "../ui/header";
import { CartButton } from "./CartButton";
import { ShareButton } from "./ShareButton";
import { Product } from "@nusrif/types";

interface HeaderProps {
  title?: string;
  showBackButton?: boolean;
  showCartButton?: boolean;
  rightElement?: React.ReactNode;
  onBackClick?: () => void;
  showShareButton?: boolean;
  product?: Product;
}
export const Header = ({ 
  title, 
  showBackButton = false, 
  showCartButton = true,
  rightElement,
  onBackClick ,
  showShareButton = false,
  product
}: HeaderProps) => {
  const combinedRightElement = (
    <div className="flex items-center gap-3">
      {rightElement}
      {showShareButton && product && <ShareButton product={product}/>}
      {showCartButton && <CartButton />}
    </div>
  );
  return (
    <UIHeader
      title={title}
      showBackButton={showBackButton}
      rightElement={combinedRightElement}
      onBackClick={onBackClick}
    />
  );
};